import { render, staticRenderFns } from "./IconRoomAmenity.vue?vue&type=template&id=c74a5f44&"
import script from "./IconRoomAmenity.vue?vue&type=script&lang=js&"
export * from "./IconRoomAmenity.vue?vue&type=script&lang=js&"
import style0 from "./IconRoomAmenity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports